import initialState from "app/initialState";
import { ReducerBase } from "common/reducer";
import SystemConfig from "domain/systemConfig";
import { SystemConfigLoaded, SystemConfigUpdated } from "./systemConfig.actions";

export default class SystemConfigReducer extends ReducerBase<SystemConfig> {

    constructor() {
        super();
        this.addHandler(SystemConfigLoaded.EventName, this.handleSystemConfigLoaded);
        this.addHandler(SystemConfigUpdated.EventName, this.handleSystemConfigUpdated);
    }

    handleSystemConfigLoaded(state: SystemConfig = initialState.systemConfig, event: SystemConfigLoaded): SystemConfig {
        return event.systemConfig;
    }

    handleSystemConfigUpdated(state: SystemConfig, event: SystemConfigUpdated): SystemConfig {
        const systemConfig = { ...state, 
            enableMasterAutoOffer: event.enableMasterAutoOffer ?? state.enableMasterAutoOffer,
            enableMasterAutoPosition: event.enableMasterAutoPosition ?? state.enableMasterAutoPosition
         };

        return systemConfig;
    }

    handleDefault(state: SystemConfig = initialState.systemConfig): SystemConfig {
        return state;
    }
} 